import React from 'react';
import { Col, Container, Row } from 'components/atoms/Grid';
import Text from 'components/atoms/Text';
import Button from 'components/atoms/Button';
import RouterLink from 'components/atoms/RouterLink';
import { useEditor } from 'providers/generalContext';
import { Helmet } from 'react-helmet';

const NotFoundListing = () => {
    const { isStoryblokEditor } = useEditor();

    return (
        <>
            <Helmet>
                <title>Página de listagem não encontrada - Lupa</title>
                <meta name="prerender-status-code" content="404" />
            </Helmet>
            <Container fluid>
                <Row justifyContent="center">
                    <Col mt="12" mb="1" size="auto 6" text="center">
                        <Text heading3>Página não encontrada</Text>
                    </Col>
                </Row>
                <Row justifyContent="center">
                    <Col size="auto 6" text="center">
                        <Text size="16">Esse endereço não existe em nosso site.</Text>
                    </Col>
                </Row>
                <Row justifyContent="center">
                    <Col mt="12" mb="30,25" size="auto 4">
                        <RouterLink to="/" editor={isStoryblokEditor} decoration="none">
                            <Button dark>Voltar à página inicial</Button>
                        </RouterLink>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default NotFoundListing;
